<template>
	<c-dialog ref="dialog" width="100vw-300" mode="slide" mask-close @close="dialogFormEditConfirm($refs.processRouteForm, arguments)" @resolve="editHandle">
		<c-form ref="processRouteForm" unit-width="100%">
			<c-form-item label="工艺路线编号">
				<c-input name="route_code" placeholder="请输入，忽略将自动生成"></c-input>
			</c-form-item>
			<c-form-item label="工艺路线名称" required>
				<c-input name="route_name"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input name="remark"></c-input>
			</c-form-item>
			
			<c-title >工序列表</c-title>
			<c-form-item :label="false" name="process_list">
				<m-operate border>
					<c-button color="main" v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" prepend-icon="tf-add" @click="addRow()">添加一行</c-button>
					<c-button color="main" v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" prepend-icon="tf-add" @click="globalDialog('processEdit' , addProcessHandle)">创建工序</c-button>
				</m-operate>
				<c-table ref="process_table" border :paging="false" width-resize>
					<c-table-column
						type="drag"
						@handle="updateProcessGroup"
					></c-table-column>
					<c-table-column label="工序" width="250" fixed="left">
						<template #default="{data}">
							<c-select name="process_id"
                                      async @search="searchProcess"
                                      :value-data="data.childrenProcess"
                                      v-model="data.process_id"
                                      @change="changeProcess($event, data)" :clear="false">
                                <template #option="{data, selected}">
                                    <select-option
                                        :name="data.name"
                                        :image="data.data.process_image"
                                        :selected="selected"
                                    ></select-option>
                                </template>
                            </c-select>
						</template>
					</c-table-column>
					<!--工序图-->
					<c-table-column label="工序图" width="60">
						<template #default="{data}">
							<c-file v-if="data.process_image" class="image" :src="data.process_image" media style="width:30px;height:30px;"></c-file>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="报工数配比" width="100">
						<template #default="{data}">
							<c-input type="stepper" step-controls="side" decimal="6" :range="[0.000001,99999999]" v-model="data.output_ratio" :clear="false"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="加工类型" width="80">
						<template #default="{data}">
							<c-select name="process_type" :options="processTypeDic" v-model="data.process_type" @change="processTypeHandle($event, data)" :clear="false">
								<template #option="{data, selected}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="data.name != '自制'"
									></select-option>
								</template>
							</c-select>
						</template>
					</c-table-column>
					<c-table-column label="检验方式" width="80">
						<template #default="{data}">
							<c-select name="test_mode" :options="testModeDic" v-model="data.test_mode" :disabled="data.process_type==2" @change="testModeHandle($event, data)" :clear="false">
								<template #option="{data, selected}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="data.name != '免检'"
									></select-option>
								</template>
							</c-select>
						</template>
					</c-table-column>
					<c-table-column v-if="systemConfig.output_sort == '1'" label="生产顺序" width="130" :ellipsis="false">
						<template #tip="{data}">
							<c-tooltip tip="说明" width="360" align="end">
								<template #tip>
									<p>【在前工序之后】：必须在上一道工序报工完成后才能报工，数量受上道工序良品数限制</p>
									<p>【与前工序同时】：可与上一道工序同步报工，数量受非同步工序的良品数限制</p>
								</template>
							</c-tooltip>
						</template>
						<template #default="{data, index}">
							<div class="flex-center">
								<ins v-if="data.group" class="process-group-pre" :type="data.group"></ins>
								<c-select v-if="index" v-model="data.production_sequence" class="flex-grow" name="production_sequence" :options="productionSequenceDic" :clear="false" @change="updateProcessGroup"></c-select>
								<p v-else class="flex-grow">首道工序</p>
							</div>
						</template>
					</c-table-column>
					<c-table-column label="自动出库" width="90">
						<template #tip="{data}">
							<c-tooltip tip="说明" width="360" align="end">
								<template #tip>
									<p>【自制】：当前工序报工后,对应工序需要用到的物料会自动出库,无需手动操作领料</p>
									<p>【外协】：当前工序对应的委外单发货时,对应外协工序需要用到的物料会自动出库,无需手动发料</p>
								</template>
							</c-tooltip>
						</template>
						<template #default="{data}">
							<c-check v-model="data.material_auto_out"></c-check>
						</template>
					</c-table-column>
					<c-table-column label="自动入库" width="90">
						<template #tip="{data}">
							<c-tooltip tip="当前工序报工后,生产的成品会自动入库,无需手动再操作入库" ></c-tooltip>
						</template>
						<template #default="{data}">
							<c-check v-model="data.product_auto_in" :disabled="data.test_mode!=1"></c-check>
						</template>
					</c-table-column>
					<c-table-column label="报工前打卡" width="100">
						<template #tip="{data}">
							<c-tooltip tip="工人开始工作时手动打卡,只有存在开始工作打卡记录才允许报工" ></c-tooltip>
						</template>
						<template #default="{data}">
							<c-check v-model="data.output_start" :disabled="data.process_type==2"></c-check>
						</template>
					</c-table-column>
					<c-table-column type="button" label="操作" width="80">
						<template #default="row">
							<c-table-button v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" icon="tf-trash" @click="row.remove(); updateProcessGroup();">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	name: 'processRouteEdit',

	data() {
		return {
			editState: false,
			route_id: 0
		}
	},
	
	computed: {
		...mapState(['systemConfig', 'processTypeDic','testModeDic','productionSequenceDic'])
	},
	
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data,is_copy) {
			this.is_copy = is_copy || false;
			this.editState = !this.is_copy && !!data;
			this.$refs.processRouteForm.clear();
			this.$refs.process_table.clear();
			if (data) {
				this.route_id = data.id;
				this.getDetail();
			}else {
				this.route_id = 0;
			}
			this.$refs.dialog.open({
				title: data ? (this.is_copy?'复制工艺路线':'编辑工艺路线') : '创建工艺路线'
			});
		},

		/*******搜索工艺路线详情*******************/
		getDetail() {
			this.request({
				url:'/process/route/detail',
				data: {
					id: this.route_id
				},
				loading: true,
				success: data => {
					if (this.is_copy){
						this.route_id = 0;
						data.route_code = '';
					}
					this.$refs.processRouteForm.set(data);
					if (data.process_list && data.process_list.length > 0){
						this.$refs.process_table.setData(data.process_list.map((item, index) => {
							let obj = item,
								next = data.process_list[index + 1] || {};
							obj.childrenProcess = [{
								name:item.process_code +' - ' +item.process_name,
								value:item.id
							}];
							return obj;
						}));
						this.updateProcessGroup();
					}else {
						this.$refs.process_table.clear();
					}
				}
			});
		},

		updateProcessGroup() {
			if (this.systemConfig.output_sort != '1') return;
			this.$nextTick(() => {
				let rows = this.$refs.process_table.getRow();
				rows.forEach((row, index) => {
					let next = rows[index + 1];
					if (index == 0) {
						row.update({
							production_sequence: 1
						})
					}
					row.update({
						group: row.data.production_sequence == 1 && next && next.data.production_sequence == 2
							? 'first'
							: row.data.production_sequence == 2
								? next && next.data.production_sequence == 2 ? 'mid' : 'last'
								: ''
					});
				});
			});
		},

		/*******搜索投料工序信息*****************/
		searchProcess(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DICPROCESS',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/******添加行数据*********/
		addRow() {
			var rowData = {};
			rowData.material_auto_out = 0;
			rowData.product_auto_in = 0;
			rowData.process_type = 1;
			rowData.test_mode = 1;
			rowData.production_sequence = 1;
			rowData.output_ratio = 1;
			rowData.output_start = 0;
			this.$refs.process_table.push(rowData)
		},
		
		/******创建工序响应方法*********/
		addProcessHandle(data) {
			data.childrenProcess = [{
				name: data.process_code +' - ' + data.process_name,
				value: data.id
			}];
			data.production_sequence = 1;
			this.$refs.process_table.push(data)
		},

		/**************变更工序下拉框数据******************/
		changeProcess(selectData,rowData){
			if (selectData.data){
				rowData.process_image = selectData.data.process_image;//工序图
				rowData.output_ratio = selectData.data.output_ratio||1;//报工数配比
				rowData.process_type = selectData.data.process_type||1;//加工类型
				rowData.test_mode = selectData.data.test_mode||1;//检验方式
				rowData.production_sequence = selectData.data.production_sequence||1;//生产顺序
				rowData.material_auto_out = selectData.data.material_auto_out||0;//自动出库
				rowData.product_auto_in = selectData.data.product_auto_in||0;//自动入库
				rowData.output_start = selectData.data.output_start||0;//报工前打卡
			}
		},

		/**加工类型变更事件*/
		processTypeHandle(selectData,rowData){
			if(selectData.value == 2){
				rowData.test_mode = 1;
				rowData.material_auto_out = 0;
				//rowData.product_auto_in = 0
				rowData.output_start = 0;
			}
		},
		
		/**检验方式变更事件*/
		testModeHandle(selectData,rowData){
			if(selectData.value != 1){
				rowData.product_auto_in = 0;
			}
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			//工序列表
			var process_list = this.$refs.process_table.getData();
			
			this.$refs.processRouteForm.submit({
				url: this.route_id==0?'/process/route/add':'/process/route/edit',
				rule: {
					route_name: '请输入工艺路线名称',
					process_list: data => {
						var flag = true;
						if(process_list.length == 0) return "至少有一条工序";
						process_list.forEach(item => {
							if(!item.process_id || !item.output_ratio){
								flag = false;
							}
						});
						if (!flag) {
							return '请完善工序信息';
						}
						process_list.forEach(item => {
							if(item.output_ratio == 0){
								flag = false;
							}
						});
						if (!flag) {
							return '报工数配比不能为0';
						}
						return true;
					}
				},
				dataFormatter: data => {
					data.id = this.route_id||0;
					data.process_list  = process_list;
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:this._editState ? '编辑工艺路线成功' : '创建工艺路线成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>